import { render, staticRenderFns } from "./StokDetayButon.vue?vue&type=template&id=7c9d0a37&"
import script from "./StokDetayButon.vue?vue&type=script&lang=js&"
export * from "./StokDetayButon.vue?vue&type=script&lang=js&"
import style0 from "./StokDetayButon.vue?vue&type=style&index=0&id=7c9d0a37&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports